module.exports = __webpack_public_path__ + "img/3.bfc83f18.svg";